module.exports = __webpack_public_path__ + "static/eggo-e1f27ea324f0a43e9195d058e72838e2.png";